<template>
  <div class="service-area">
    <CTitle title="服务专区"></CTitle>
    <img class="area mt-30" src="@/assets/img/performance/area-1.png" alt="" @click="goto('/demand/apply')">
    <img class="area" src="@/assets/img/performance/area-2.png" alt="" @click="gotoZc">
  </div>
</template>

<script>
import CTitle from "@/components/Title/index.vue";

export default {
  name: "ServiceArea",
  components: {CTitle},
  data() {
    return {

    }
  },
  methods: {
    goto(path) {
      this.$router.push({
        path: path
      })
    },
    gotoZc() {
      window.location.href = "https://qf.ningbo.gov.cn/qykj/projectDetail/32"
    }
  }
}
</script>

<style scoped lang="scss">
.service-area {
  width: 300px;
  height: 493px;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.0715);
  padding: 40px;

  .area {
    width: 220px;
    height: 108px;
    margin-bottom: 20px;
    cursor: pointer;
  }
}
</style>
